import type {VoiceLanguage} from '@Panels/ai-voice-panel/ai-voice-panel.types';

export interface VoiceProfileSelectorProps {
  language: VoiceLanguage;
  selectedProfileId: number;
  onProfileSelected: (id: number) => void;
}

export const VOICE_PROFILE_SELECTOR_MODAL_PANEL_ID = 'ai-voice-profile-selector-modal';
export const VOICE_PROFILES_MODAL_MAX_HEIGHT = '500px';
